<template>
  <div class="el-section">
    <dash-settlements></dash-settlements>
  </div>
</template>

<script>
import '@pagarme/settlements/web-comp'

export default {
  name: 'settlements'
}
</script>
